module.exports = __webpack_public_path__ + "logoFooter.png?8944158b16d40dc60e3c8711c2c4bfc2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoFooter.png
// module id = 891
// module chunks = 0